/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Properties_LabelInputs */

const en_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties to Merge`)
};

const fr_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriétés à fusionner`)
};

const de_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenzuführende Eigenschaften`)
};

const it_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietà da unire`)
};

const ru_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свойства для объединения`)
};

const es_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propiedades para fusionar`)
};

const zh_cn2_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要合并的属性`)
};

const ja_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統合するプロパティ`)
};

const hi_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय करने के लिए संपत्तियाँ`)
};

const pt_pt2_metadata_merge_properties_label = /** @type {(inputs: Metadata_Merge_Properties_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriedades a mesclar`)
};

/**
* | output |
* | --- |
* | "Properties to Merge" |
*
* @param {Metadata_Merge_Properties_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_properties_label = /** @type {((inputs?: Metadata_Merge_Properties_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Properties_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_properties_label(inputs)
	if (locale === "de") return de_metadata_merge_properties_label(inputs)
	if (locale === "it") return it_metadata_merge_properties_label(inputs)
	if (locale === "ru") return ru_metadata_merge_properties_label(inputs)
	if (locale === "es") return es_metadata_merge_properties_label(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_properties_label(inputs)
	if (locale === "ja") return ja_metadata_merge_properties_label(inputs)
	if (locale === "hi") return hi_metadata_merge_properties_label(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_properties_label(inputs)
	return en_metadata_merge_properties_label(inputs)
});